export default __webpack_public_path__ + "static/media/unverified.075fc2d1.svg";